/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customerWalletDataSchema = z.object({
	balance: z.number(),
	pending: z.number().default(0),
})

export type CustomerWalletDataSchema = z.infer<typeof customerWalletDataSchema>
